export class StatsTemplateBreadcrumbs {
    public static statsUruchomieniaIndexBreadcrumbsObject(): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Analiza statystyk',
                disabled: true,
                href: '/stats-uruchomienia'
            }
        ];
    }

    public static statsUruchomieniaProductBreadcrumbsObject(productId: string): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Analiza statystyk',
                disabled: false,
                href: '/stats-uruchomienia'
            },
            {
                text: 'Produkt #' + productId,
                disabled: true,
                href: '/stats-uruchomienia/product/' + productId
            }
        ];
    }

    public static statsUruchomieniaDetailedProductBreadcrumbsObject(productId: string): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Statystyki uruchomień produktu #' + productId + ' - przeglądanie',
                disabled: true,
                href: '/stats-uruchomienia-details/' + productId
            }
        ];
    }

    public static statsPobraniaIndexBreadcrumbsObject(): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Analiza statystyk',
                disabled: true,
                href: '/stats-pobrania'
            }
        ];
    }

    public static statsPobraniaProductBreadcrumbsObject(productId: string): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Analiza statystyk',
                disabled: false,
                href: '/stats-pobrania'
            },
            {
                text: 'Produkt #' + productId,
                disabled: true,
                href: '/stats-pobrania/product/' + productId
            }
        ];
    }

    public static statsPobraniaDetailedProductBreadcrumbsObject(productId: string): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Statystyki pobrań produktu #' + productId + ' - przeglądanie',
                disabled: true,
                href: '/stats-pobrania-details/' + productId
            }
        ];
    }

    public static statsDeklaracjeIndexBreadcrumbsObject(): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Analiza statystyk',
                disabled: true,
                href: '/stats-deklaracje'
            }
        ];
    }

    public static statsDeklaracjeProductBreadcrumbsObject(productId: string): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Analiza statystyk',
                disabled: false,
                href: '/stats-deklaracje'
            },
            {
                text: 'Produkt #' + productId,
                disabled: true,
                href: '/stats-deklaracje/product/' + productId
            }
        ];
    }

    public static statsDeklaracjeDetailedProductBreadcrumbsObject(productId: string): Array<object> {
        return [
            {
                text: 'Start',
                disabled: false,
                href: '/'
            },
            {
                text: 'Statystyki deklaracji dla produktu #' + productId + ' - przeglądanie',
                disabled: true,
                href: '/stats-deklaracje-details/' + productId
            }
        ];
    }
}
